import React from 'react'
import { useOrderListContext } from './Context'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxHeaderCell, MenuHeaderCell } from '@ztechapps/webui.data-tools'

export const ListHeader = (props: HeaderRowConfig) => {
  const listContext = useOrderListContext()
  const { toggleSelectAll, hasSelectedAll } = listContext.orderListWithSelection
  return (
    <>
      <MenuHeaderCell />

      <CheckboxHeaderCell onChange={toggleSelectAll} checked={hasSelectedAll} />

      {props._renderDataHeaderCell()}
    </>
  )
}
